/**
 * 获取美元价格展示
 * @param price - 价格
 * @returns 美元价格
 */
export const getDollarPriceDisplay = (price: number) => {
    return `US$ ${price}`;
};
